function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  mutateValue,
  getValue
} = require('@truqc/content-path');
const safeParseContent = content => {
  let parsedContent = content;
  if (typeof parsedContent === 'string') {
    parsedContent = JSON.parse(parsedContent);
  }
  return parsedContent;
};
const isContentPipelineMatch = (content, pipelineId) => {
  const parsedContent = safeParseContent(content);
  const pipelineReferencePath = '/pipeline';
  const pipelineReference = getValue(pipelineReferencePath, parsedContent);
  if (!pipelineReference) {
    return false;
  }
  const [key] = Object.keys(pipelineReference);
  if (!key) {
    return false;
  }
  return pipelineId === key;
};
const isContentPathMatch = (content, path) => {
  if (!path) {
    return true;
  }
  const parsedContent = safeParseContent(content);
  const matchedValue = getValue(path, parsedContent);
  return matchedValue !== undefined;
};
const isFormMatch = (content, formID) => {
  if (!formID) {
    return true;
  }
  const parsedContent = safeParseContent(content);
  return parsedContent.id === formID;
};

/**
  * @function evalute - evaluate emcoGetPrintableWorkLogsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const formTypeIdentifier = await sourceEvaluator(source.formTypeIdentifier);
  if (!formTypeIdentifier) {
    return undefined;
  }
  const pipelineId = await sourceEvaluator(source.pipelineId);
  if (!pipelineId) {
    return undefined;
  }
  const shouldWrite = await sourceEvaluator(source.shouldWrite);
  const formID = await sourceEvaluator(source.formID);
  const filterByContentPath = await sourceEvaluator(source.filterByContentPath);
  let statusContentPath = await sourceEvaluator(source.statusContentPath);
  if (!statusContentPath) {
    statusContentPath = '/general/status';
  }
  const statusIn = (await sourceEvaluator(source.statusIn)) || 'QA Approved';
  const statusOut = (await sourceEvaluator(source.statusOut)) || 'Printed';
  const getPrintableForms = {
    type: 'queryEntityBehavior',
    entityName: 'Form',
    properties: ['id', 'content'],
    equals: {
      'formType/identifier': formTypeIdentifier
    },
    ifContent: {
      atPath: statusContentPath,
      equals: statusIn
    }
  };
  const printableForms = (await sourceEvaluator(getPrintableForms)) || [];
  const result = printableForms.filter(form => isContentPipelineMatch(form === null || form === void 0 ? void 0 : form.content, pipelineId)).filter(form => isContentPathMatch(form === null || form === void 0 ? void 0 : form.content, filterByContentPath)).filter(form => isFormMatch(form === null || form === void 0 ? void 0 : form.content, formID));
  if (!result || result.length === 0) {
    return undefined;
  }
  const output = result.reduce((acc, item, index) => _objectSpread(_objectSpread({}, acc), {}, {
    [`workLogCollectionItem${index}`]: {
      workLogForm: {
        [item.id]: {
          _formRef: item.id
        }
      }
    }
  }), {});
  if (shouldWrite === false) {
    // Skip writing back to the forms
    return output;
  }
  const setPatch = {};
  mutateValue(statusContentPath, setPatch, statusOut);
  for (let i = 0; i < result.length; i += 1) {
    const patchContentBehaviorSource = {
      type: 'patchContentBehavior',
      unsafePatch: true,
      entityName: 'Form',
      id: result[i].id,
      patches: [setPatch]
    };
    // eslint-disable-next-line no-await-in-loop
    await sourceEvaluator(patchContentBehaviorSource, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  }
  return output;
};
module.exports = {
  evaluate
};